import { GridColumnType } from "../../../../components/molGrid/libs/data/gridColumnType";

export const unAssignUnassignMergeGridConfig = {
  isRowSelectable: false,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "Basis Type",
      fieldName: "basisType",
      colStyle: {
        textAlign: "left",
        width: "60%",
      },
      allowShort: true,
    },
    {
      name: "Merge Field Prefix",
      fieldName: "mergeFieldPrefix",
      colStyle: {
        textAlign: "center",
        width: "25%",
      },
      allowShort: true,
    },
    {
      name: "Choose",
      fieldName: "choose",
      colType: GridColumnType.CHECKBOX,
      colSettings: {
        isChecked: false,
        isDisabled: false,
      },
      colStyle: {
        textAlign: "center",
        width: "15%",
      },
      allowShort: false,
    },
    
  ],
};
export const assignUnassignMergeGridConfig = {
  isRowSelectable: false,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "Basis Type",
      fieldName: "basisType",
      colStyle: {
        textAlign: "left",
        width: "60%",
      },
      allowShort: true,
    },
    {
      name: "Merge Field Prefix",
      fieldName: "mergeFieldPrefix",
      colStyle: {
        textAlign: "center",
        width: "25%",
      },
      allowShort: true,
    },
    {
      name: "Choose",
      fieldName: "choose",
      colType: GridColumnType.CHECKBOX,
      colSettings: {
        isChecked: false,
        isDisabled: false,
      },
      colStyle: {
        textAlign: "center",
        width: "15%",
      },
      allowShort: false,
    },
    
  ],
}
